import { Map, fromJS } from 'immutable';
import actions from './actions';

const initState = new Map({
  unactionedNotifications: [],
  actionedNotifications: [],  
  untouchedNotificationCount: null,
  totalActioned: 0,
  totalUnactioned: 0,
  loadingNotifications: false,
  loadingNotificationsFailed: null,
  loadingActioned: false,
  loadingUnactioned: false,
  compulsoryNotifications: [],
  totalCompulsory: 0,
  loadingCompulsory: false,
  loadingMoreCompulsory: false,
});

export default function notificationsReducer(state = initState, action) {
  switch (action.type) {
    // DO_GET_NOTIFICATIONS
    case actions.DO_GET_NOTIFICATIONS:
      return state
        .set('unactionedNotifications', [])
        .set('actionedNotifications', [])        
        .set('untouchedNotificationCount', 0)
        .set('totalActioned', 0)
        .set('totalUnactioned', 0)
        .set('loadingNotifications', true)
        .set('loadingNotificationsFailed', null)
    case actions.DO_GET_NOTIFICATIONS_SUCCEEDED:
      return state
        .set('unactionedNotifications', action.payload.unactionedNotifications)
        .set('actionedNotifications', action.payload.actionedNotifications)
        .set('untouchedNotificationCount', action.payload.untouchedNotificationCount)        
        .set('totalActioned', action.payload.totalActioned)
        .set('totalUnactioned', action.payload.totalUnactioned)
        .set('loadingNotifications', false)
        .set('loadingNotificationsFailed', null)
    case actions.DO_GET_NOTIFICATIONS_FAILED:
      return state
        .set('unactionedNotifications', [])
        .set('actionedNotifications', [])
        .set('untouchedNotificationCount', 0)
        .set('totalActioned', 0)
        .set('totalUnactioned', 0)
        .set('loadingNotifications', false)
        .set('loadingNotificationsFailed', action.payload)
    // DO_ADD_NOTIFICATION
    case actions.DO_ADD_NOTIFICATION: {
      const notifs = [ ...state.get('unactionedNotifications') ];
      notifs.unshift(action.payload);
      const compulsoryNotifs = [ ...state.get('compulsoryNotifications') ];
      const totalCompulsory = action.payload.compulsoryAction ? state.get('totalCompulsory') + 1 : state.get('totalCompulsory');
      if (action.payload.compulsoryAction) {
        compulsoryNotifs.unshift(action.payload);
      }
      return state
        .set('unactionedNotifications', notifs)
        .set('untouchedNotificationCount', state.get('untouchedNotificationCount') + 1)
        .set('totalUnactioned', state.get('totalUnactioned') + 1)
        .set('compulsoryNotifications', compulsoryNotifs)
        .set('totalCompulsory', totalCompulsory)
    }
    // DO_LOAD_ACTIONED
    case actions.DO_LOAD_ACTIONED: {
      console.log('loading actioned');
      return state
        .set('loadingActioned', true)
    }
    case actions.DO_LOAD_ACTIONED_SUCCEEDED: {
      const notifs = [ ...state.get('actionedNotifications') ];
      notifs.push(...action.payload.actionedNotifications)
      return state
        .set('actionedNotifications', notifs)
        .set('totalActioned', action.payload.totalActioned)
        .set('loadingActioned', false)
    }
    case actions.DO_LOAD_ACTIONED_FAILED:
      return state
        .set('loadingActioned', false)
    // DO_LOAD_UNACTIONED
    case actions.DO_LOAD_UNACTIONED:
      return state
        .set('loadingUnactioned', true)
    case actions.DO_LOAD_UNACTIONED_SUCCEEDED: {
      const notifs = [ ...state.get('unactionedNotifications') ];
      notifs.push(...action.payload.unactionedNotifications)
      return state
        .set('unactionedNotifications', notifs)
        .set('totalUnactioned', action.payload.totalUnactioned)
        .set('loadingUnactioned', false)
    }
    case actions.DO_LOAD_UNACTIONED_FAILED:
      return state
        .set('loadingUnactioned', false)
    case actions.DO_SEE_ALL_NOTIFICATIONS_SUCCEEDED:
      return state
        .set('untouchedNotificationCount', action.payload.untouchedNotificationCount)
    case actions.DO_GET_COMPULSORY_NOTIFICATIONS:
      return state
        .set('compulsoryNotifications', [])
        .set('totalCompulsory', 0)
        .set('loadingCompulsory', true)
    case actions.DO_GET_COMPULSORY_NOTIFICATIONS_SUCCEEDED:
      return state
        .set('compulsoryNotifications', action.payload.compulsoryNotifications)
        .set('totalCompulsory', action.payload.totalCompulsory)
        .set('loadingCompulsory', false)
    case actions.DO_GET_COMPULSORY_NOTIFICATIONS_FAILED:
      return state
        .set('loadingCompulsory', false)
    case actions.DO_LOAD_COMPULSORY_NOTIFICATIONS:
      return state
        .set('loadingMoreCompulsory', true)
    case actions.DO_LOAD_COMPULSORY_NOTIFICATIONS_SUCCEEDED: {
      const notifs = [ ...state.get('compulsoryNotifications') ];
      notifs.push(...action.payload.compulsoryNotifications);
      return state
        .set('compulsoryNotifications', notifs)
        .set('totalCompulsory', action.payload.totalCompulsory)
        .set('loadingMoreCompulsory', false)
    }
    case actions.DO_LOAD_COMPULSORY_NOTIFICATIONS_FAILED:
      return state
        .set('loadingMoreCompulsory', false)
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/notifications/reducer.js